import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    loading: true,
    error: false
}

export const fetchAccessToken = createAsyncThunk('data/fetchAccessToken', async (codeParam, { rejectWithValue }) => {
    try {
        const data = {
            client_id: process.env.REACT_APP_CLIENT_ID,
            redirect_uri: window.location.origin + "/home",
            grant_type: 'authorization_code',
            scope: 'openid profile address email phone',
            code_verifier: sessionStorage.getItem('codeVerifier'),
            code: codeParam,
        };

        const response = await axios.post(
            process.env.REACT_APP_TOKEN_URL,
            new URLSearchParams(data).toString(), // Ensure data is URL-encoded
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        );

        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.message || 'Unexpected error');
    }
});


const accessTokenSlice = createSlice({
    name: 'accessToken',
    initialState,
    reducers: {
        authLoading: (state, action) => {
            state.loading = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAccessToken.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(fetchAccessToken.fulfilled, (state, action) => {
                const authResponse = {};
                const idToken = action.payload.id_token;
                const parsedIdToken = JSON.parse(atob(idToken.split('.')[1]));
                authResponse.name = parsedIdToken.displayName;
                authResponse.userName = parsedIdToken.username;
                authResponse.email = parsedIdToken.email;
                authResponse.groups = parsedIdToken.msad_groups;

                if (Object.keys(authResponse).length !== 0) {
                    localStorage.setItem("name", authResponse.name);
                    localStorage.setItem("email", authResponse.email);
                    localStorage.setItem("userName", authResponse.userName);
                    localStorage.setItem("cnsaccess", authResponse.groups);
                    sessionStorage.setItem("isAuthenticated", true);
                }
                state.loading = false;
                state.error = false;
            })
            .addCase(fetchAccessToken.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            });
    }
})

export const { authLoading } = accessTokenSlice.actions;
export default accessTokenSlice.reducer